import { all } from 'redux-saga/effects';
import { watchRequestStructure } from './sdmx/structure';
import { watchParseData, watchRequestDataFile } from './sdmx/data';
import { watchRequestMetadata } from './sdmx/metadata';
import { chartSaga } from './chart';

export default function* rootSaga() {
  yield all([
    watchRequestStructure(),
    watchRequestDataFile(),
    watchParseData(),
    chartSaga(),
    watchRequestMetadata(),
  ]);
}
